import handleRequest from './handleRequest';
import handleRefreshToken from './handleRefreshToken';
import { parseJwt } from '../../helper/Converters';
import systemSlice from '../../redux/systemSlice';
import myUserSlice from '../../redux/myUserSlice';
import store from '../../redux/store';
import requestErrorHandler from './requestErrorHandler';





const CreateAction = async (props: { isCreateNewApp?: { duration: number, animationText?: string }, headers?: any, path: any, params?: any, method: "patch" | "post" | "get", isFileUploading: boolean, data?: any, showPreLoader: boolean, toastMessage?: { success: string, error: string }, hideToastMessages?: boolean, hideSuccessToastMessages?: boolean }) => {
    const storeData = store.getState()


    const { isCreateNewApp, path, params, method, isFileUploading, data, showPreLoader, toastMessage, hideToastMessages, hideSuccessToastMessages } = props



    let token: any = localStorage.getItem("token")


    const tokenData = parseJwt(token)
    const tokenExpiration = tokenData?.exp
    const currentTime = (new Date()).getTime()

    if (token && tokenExpiration && tokenExpiration * 1000 <= currentTime) {
        const refreshResponse = await handleRefreshToken()
        if (refreshResponse?.error) return refreshResponse
        token = refreshResponse?.result?.resultData?.token
        const newRefreshToken = refreshResponse?.result?.resultData?.refreshToken

        localStorage.setItem("token", token)
        localStorage.setItem("refreshToken", newRefreshToken)

    }

    const auth = { "Authorization": `Bearer ${token}` }
    const defaultHeaders = props.headers || {};
    const fileUploadHeaders = isFileUploading ? { 'Content-Type': 'multipart/form-data' } : {};
    const storeId = localStorage.getItem('activeStoreId');
    const transactionid = localStorage.getItem('transactionid')
    const otp = localStorage.getItem('otp')

    const appThemeId = storeData.themeSlice.themeId;
    const sessionId = sessionStorage.getItem('sessionId');
    const storeHeaders = { "mobligo-storeid": storeId, "mobileappthemeid": appThemeId, "sessionId": sessionId, "otp": otp, "transactionid": transactionid }
    const url = `${process.env.REACT_APP_API_URL}${props.path}`
    const headers = { ...defaultHeaders, ...fileUploadHeaders, ...storeHeaders, ...auth }
    const responseData = { method, url, data, headers, params, showPreLoader, isCreateNewApp, createActionProps: props }
    const response = await handleRequest(responseData)
    if (!(response?.errorType === "OTP")) {
        if (response?.error && !hideToastMessages) requestErrorHandler({ response })
        else if (!hideToastMessages && !hideSuccessToastMessages && (toastMessage?.success || (method !== "get" && (!data?.select && !data?.orderBy && !data?.pagination && !data?.where)))) store.dispatch(systemSlice.actions.setToastSuccess({ detail: toastMessage?.success || "success" }))
    }

    if (response?.result?.redirect) {
        window.location.href = response?.result?.redirect
        return
    }
    return response

};

export default CreateAction;


